<ul class="social-button-list d-flex align-items-center gap-2">
  @for (channel of channels(); track channel.id) {
    <li class="social-button-list__item">
      <a
        [href]="channel.url"
        target="_blank"
        class="button button-icon button--primary-subtle-variant button--lg"
        [trackLinkClick]="channel.url"
        [trackContext]="context()"
      >
        <span class="sr-only">{{ channel.title }}</span>

        @let icon = channel.icon || (channel.url | socialIcon);

        @if (channel.imageUrl) {
          <img [src]="channel.imageUrl" [alt]="channel.title" />
        } @else if (icon) {
          <fstr-icon [anchor]="icon" [title]="channel.title"></fstr-icon>
        }
      </a>
    </li>
  }
</ul>
